//import {USERLIST} from '../actions';
import {findIndex} from 'lodash';

let namespace = 'purorder_';

const initialState = {  
	  data:[],
	  dataLoading: true,	  
	  dataFetchProps: {order:[['id','desc']],distinct:true,include:[{model:'pur_order_file',as:'m_purFile',attributes:['id','contract_local_url','status','attachmenttype','contract_bank_url']},
			  {model:'pur_pay',as:'m_orderpay',attributes:['id','project_id','partner_order_no','order_no','pay_time','loan_no','total_pay_amount','amount','interest','repay_date','remain_loan_amount','loan_end_date']},
			  {model:'pur_after_loan',as:'m_afterLoan',attributes:['id','apply_no','code_list','status',"rule_name" ,"add_doc_reason"]},
			  {model:'pur_repay',as:'m_purRepay',attributes:['id','cust_name','contract_id','loan_no','loan_amount','loan_date','repay_date','remain_loan_amount','partner_order_no','settle_flag','amount','interest','penalty_interest','compound_interest','repay_notice_res']},
			  {model:'pur_order_record',as:'m_orderRecord',attributes:['engineering_name','project_type']},
		  ],},
      modalVisible: false,
	  modalType: 'create',
		orderDetailVisible: false,
	  pwdModalVisible: false,
	  selectedRow: {},  
	  selectedRowIndex: -1,  
	  selectedRows: [],  
	  clickRow:{},
      selectedRowKeys: [],
	  offset:0,
	  limit:0,
	purRepayDetailVisible:false,
	  pagination: {
		  showSizeChanger: true,
		  showQuickJumper: true,
		  showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
		  pageSizeOptions: ['5','10', '20', '40', '100'],
		  defaultPageSize: 5,
		  pageSize:5,
		  current: 1,		 
		},	  
	  
	  
}

export default function(state=initialState, action) {
  switch (action.type) {
    case namespace+"forcedUpdate": {		
	
      return {
        ...state,
        ...action.payload
      }
    }
	case namespace+"updateDataById": {
		
		let newData = state.data
		
		let {selectedRowIndex, id} = action.payload		
		
		newData[selectedRowIndex] = action.payload.data		
		
		return {...state, selectedRow: action.payload.data, data: newData}
	}

	case namespace+"deleteDataById": {
		
		let newData = state.data
		let {selectedRowIndex, id} = action.payload
		let i = selectedRowIndex ? selectedRowIndex : findIndex(newData, {id: id})
		newData.splice(i,1)
		
		return {...state, data: newData}
	}
	
	case namespace+"addOneRowData": {
		
		return {...state, data: [action.payload.data, ...state.data]}
	}
	
	case namespace+"RemoveDataByIndex": {
		
		let newData = state.data;		
		let {selectedRowIndex} = action.payload		
		newData.splice(selectedRowIndex,1)
		
		return {...state, data: newData}
	}
	
    default:
      return state;
  }
}